import login from '@/components/login'
import dashboard from '@/components/dashboard'
import overview from '@/components/overview'

import settings from '@/components/settings/index'
import algemeen from '@/components/settings/algemeen'
import keys from '@/components/settings/keys'
import templates from '@/components/settings/templates'
import logs from '@/components/settings/logs'
import users from '@/components/settings/users/index'
import editUser from '@/components/settings/users/edit'
import system from '@/components/settings/system'

import invoices from '@/components/invoices/index'
import newInvoices from '@/components/invoices/new'
import sales from '@/components/invoices/sales/index'
import purchase from '@/components/invoices/purchase/index'

import receipts from '@/components/receipts/index'
import receiptProcessing from '@/components/receipts/processing'
import receiptConfirmed from '@/components/receipts/confirmed'
import receiptConfirmation from '@/components/receipts/confirmation/index'
import receiptConcept from '@/components/receipts/concept/index'
import receiptCreateConcept from '@/components/receipts/concept/edit'

import creditcard from '@/components/creditcard/index'
import creditcardProcessing from '@/components/creditcard/processing'
import creditcardConfirmed from '@/components/creditcard/confirmed'
import creditcardConfirmation from '@/components/creditcard/confirmation/index'
import creditcardConfirmReceipt from '@/components/creditcard/confirmation/edit'
import creditcardEdit from '@/components/creditcard/edit'
import creditcardCompleted from '@/components/creditcard/completed'

import crediteuren from '@/components/crediteuren'
import debiteuren from '@/components/debiteuren'

export default [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/',
    name: 'dashboard',
    component: dashboard,
    meta: {
      auth: true
    },
    children: [
      { path: '/overzicht', name: 'overview', component: overview },
      { path: '/instellingen',
        component: settings,
        children: [
          { path: '', name: 'settings.general', component: algemeen },
          { path: 'keys', name: 'settings.keys', component: keys },
          { path: 'templates', name: 'settings.templates', component: templates },
          { path: 'gebruikers', name: 'settings.users', component: users },
          { path: 'gebruiker/aanmaken', name: 'settings.new.user', component: editUser },
          { path: 'gebruiker/bewerken/:id', name: 'settings.edit.user', component: editUser },
          { path: 'logs', name: 'settings.logs', component: logs },
          { path: 'system', name: 'settings.system', component: system }
        ]
      },
      { path: '/facturen',
        component: invoices,
        children: [
          { path: '', name: 'invoices.confirmation', component: receiptConfirmation },
          { path: 'inkoop', name: 'invoices.purchase', component: purchase },
          { path: 'nieuw', name: 'invoices.new', component: newInvoices },
          { path: 'verkoop', name: 'invoices.sales', component: sales }
        ]
      },
      { path: '/bonnen',
        component: receipts,
        children: [
          { path: '', name: 'receipts.processing', component: receiptProcessing },
          { path: 'concepten', name: 'receipts.concept', component: receiptConcept },
          { path: 'factureren', name: 'receipts.confirmed', component: receiptConfirmed },
          { path: 'concept/bewerk/:id',
            name: 'receipts.edit.concept',
            component: receiptCreateConcept,
            meta: {
              target: 'concept'
            }
          },
          { path: 'invoer/bewerk/:id',
            name: 'receipts.edit.processing',
            component: receiptCreateConcept,
            meta: {
              target: 'processing'
            }
          }
        ]
      },
      { path: '/creditcard',
        component: creditcard,
        children: [
          { path: '', name: 'creditcard.processing', component: creditcardProcessing },
          { path: 'factureren', name: 'creditcard.confirmed', component: creditcardConfirmed },
          { path: 'controle', name: 'creditcard.confirmation', component: creditcardConfirmation },
          { path: 'controle/:id', name: 'creditcard.confirmation.watch', component: creditcardConfirmReceipt },
          { path: 'bewerk/:id', name: 'creditcard.edit', component: creditcardEdit },
          { path: 'afgerond', name: 'creditcard.completed', component: creditcardCompleted }
        ]
      },
      { path: '/crediteuren', name: 'crediteuren', component: crediteuren },
      { path: '/debiteuren', name: 'debiteuren', component: debiteuren }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js